import {Card, Space, Tag, Typography} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {AiMonitoringBrandAnalysisType} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

import {TONALITY_LANG_KEY_MAP, TONALITY_TAG_COLOR_MAP} from './brand-analysis-const';
import {TonalityAspectRow} from './tonality-aspect-row';
import * as styles from './tonality-aspects.scss';

type PropsType = {
    analysis: AiMonitoringBrandAnalysisType;
};

export function TonalityAspects(props: PropsType): JSX.Element {
    const {analysis} = props;
    const {overall, aspects} = analysis.tonality;

    return (
        <Card
            size="small"
            title={
                <Space align="center" size="small">
                    <Locale stringKey="AI_BRAND_MONITORING__ANALYSIS__TONALITY_TITLE" />
                    <Tag color={TONALITY_TAG_COLOR_MAP[overall]}>
                        <Locale stringKey={TONALITY_LANG_KEY_MAP[overall]} />
                    </Tag>
                </Space>
            }
        >
            <Typography.Text className={styles.tonality_aspects__hint} type="secondary">
                <Locale stringKey="AI_BRAND_MONITORING__ANALYSIS__ASPECTS_HINT" />
            </Typography.Text>
            {aspects.map((aspect) => (
                <TonalityAspectRow aspect={aspect} key={aspect.name} />
            ))}
        </Card>
    );
}
